import { render, staticRenderFns } from "./SlackModal.vue?vue&type=template&id=32a850d8"
import script from "./SlackModal.vue?vue&type=script&lang=js"
export * from "./SlackModal.vue?vue&type=script&lang=js"
import style0 from "./SlackModal.vue?vue&type=style&index=0&id=32a850d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports